import React from 'react';
import classNames from 'classnames/bind';
import Icon from "../Icon";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var SaleRow = function SaleRow(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('saleRow', className),
    "data-t-id": "components-SaleRow"
  }, icon || /*#__PURE__*/React.createElement(Icon, {
    className: cx('icon'),
    name: "present"
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('text')
  }, children));
};
export default SaleRow;